var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.27 29.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d2a784;}.cls-2{fill:#1c2c58;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.64,
    cy: 14.64,
    r: 14.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.64,7.08c2.46,0,2.75,0,3.72.06a5.25,5.25,0,0,1,1.71.31,2.91,2.91,0,0,1,1.06.69,2.78,2.78,0,0,1,.69,1.06,5,5,0,0,1,.32,1.71c0,1,.05,1.27.05,3.73s0,2.75-.05,3.72a4.92,4.92,0,0,1-.32,1.71,3.06,3.06,0,0,1-1.75,1.75,4.92,4.92,0,0,1-1.71.32c-1,0-1.26.05-3.72.05s-2.75,0-3.73-.05a5,5,0,0,1-1.71-.32,2.78,2.78,0,0,1-1.06-.69,2.91,2.91,0,0,1-.69-1.06,5.25,5.25,0,0,1-.31-1.71c0-1-.06-1.26-.06-3.72s0-2.75.06-3.73A5.31,5.31,0,0,1,7.45,9.2,3.06,3.06,0,0,1,9.2,7.45a5.31,5.31,0,0,1,1.71-.31c1,0,1.27-.06,3.73-.06m0-1.66c-2.51,0-2.82,0-3.8.06a6.63,6.63,0,0,0-2.24.43A4.69,4.69,0,0,0,5.91,8.6a6.63,6.63,0,0,0-.43,2.24c-.05,1-.06,1.29-.06,3.8s0,2.81.06,3.8a6.51,6.51,0,0,0,.43,2.23,4.67,4.67,0,0,0,2.69,2.7,6.89,6.89,0,0,0,2.24.43c1,0,1.29.05,3.8.05s2.81,0,3.8-.05a6.76,6.76,0,0,0,2.23-.43,4.65,4.65,0,0,0,2.7-2.7,6.76,6.76,0,0,0,.43-2.23c0-1,.05-1.3.05-3.8s0-2.82-.05-3.8a6.89,6.89,0,0,0-.43-2.24,4.67,4.67,0,0,0-2.7-2.69,6.51,6.51,0,0,0-2.23-.43c-1-.05-1.3-.06-3.8-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.64,9.9a4.74,4.74,0,1,0,4.73,4.74A4.74,4.74,0,0,0,14.64,9.9Zm0,7.81a3.07,3.07,0,1,1,3.07-3.07A3.07,3.07,0,0,1,14.64,17.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.56,
    cy: 9.72,
    r: 1.11
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.501b604e3b568518bf4d08ac51fcc60d.svg";
export { ForwardRef as ReactComponent };